import { Box, styled } from "@mui/material";
import { useContext } from "react";
import { DashboardSidebar } from "./Sidebar";
import { AuthContext } from "../../store";

const DashboardLayoutRoot = styled("div")(({ theme, collapse }) => ({
  display: "flex",
  flex: "1 1 auto",
  maxWidth: "100%",
  paddingLeft: collapse ? 240 : 65,
  transition: "padding-left .7s ease",
}));

export const DashboardLayout = (props) => {
  const { children } = props;
  const { auth } = useContext(AuthContext);

  return (
    <>
      <DashboardLayoutRoot collapse={auth.isSidebarOpen}>
        <Box
          sx={{
            display: "flex",
            flex: "1 1 auto",
            flexDirection: "column",
            width: "100%",
            transition: "padding-left .7s ease",
          }}
        >
          {children}
        </Box>
      </DashboardLayoutRoot>
      <DashboardSidebar open={auth.isSidebarOpen} />
    </>
  );
};
